<template>
  <b-row class="px-sm-4 px-md-4 px-lg-0 pt-sm-3">
    <b-col cols="12" class="d-flex align-items-center justify-content-between" >
      <PageTitle title="Estatísticas" />

      <b-button
        pill
        variant="primary"
        title="Atualizar"
        @click="() => {list(); getGraph(); getStats();}"
      >
        <i class="fas fa-sync"></i>
      </b-button>
    </b-col>
    
    <b-col class="mt-2">
      <b-button 
        class="mr-3" 
        variant="danger"
        @click="$refs.videoManual.toggleOpen({ 
          url: 'https://www.youtube.com/watch?v=yXYrCi9k2Fw&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=8', 
          title: 'Estatísticas' 
        })"
        >
        <i class="fas fa-play mr-1"></i>
        Ver video
      </b-button>
      <a class="btn btn-success" href="https://api.construp.com.br/assets/Manual - Estatisticas .pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
    </b-col>
  
   
    <b-col cols="12" class="mt-4 mb-1">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        @update:startDate="searchTimeOut"
        @update:endDate="searchTimeOut"
      />
    </b-col>

    <b-col cols="12" sm="6" class="mt-3">
      <input
        type="text"
        v-model.trim="fields.clientName"
        class="form-control"
        placeholder="Nome do cliente"
        @input="searchTimeOut"
      />
    </b-col>
    <b-col cols="12" sm="6" class="mt-3">
      <input
        min="0"
        type="number"
        v-model.number="fields.orderNumber"
        @input="() => {searchTimeOut(); handleOrderNumber();}"
        class="form-control"
        placeholder="Número do pedido"
      />
    </b-col>
    <b-col cols="12" class="mt-3">
      <b-button variant="success" @click="pesquisar()">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>

    <b-col cols="12 mt-4">
      <h5 class="font-weight-bold">Status do pedido</h5>
      <div class="mb-4">
        <h4>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.SEPARATING_ORDER) ? 'primary' : 'light'"
            class="pointer"
            @click="addStatus(ORDER_STATUS.SEPARATING_ORDER)"
          > {{ getOrderStatusText(ORDER_STATUS.SEPARATING_ORDER) }}
          </b-badge>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.WAITING_PAYMENT) ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addStatus(ORDER_STATUS.WAITING_PAYMENT)"
          > {{ getOrderStatusText(ORDER_STATUS.WAITING_PAYMENT) }}
          </b-badge>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.SENT) ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addStatus(ORDER_STATUS.SENT)"
          > {{ getOrderStatusText(ORDER_STATUS.SENT) }}
          </b-badge>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.READY_FOR_PICKUP) ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addStatus(ORDER_STATUS.READY_FOR_PICKUP)"
          > {{ getOrderStatusText(ORDER_STATUS.READY_FOR_PICKUP) }}
          </b-badge>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.DELIVERED) ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addStatus(ORDER_STATUS.DELIVERED)"
          > {{ getOrderStatusText(ORDER_STATUS.DELIVERED) }}
          </b-badge>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.CANCELED) ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addStatus(ORDER_STATUS.CANCELED)"
          > {{ getOrderStatusText(ORDER_STATUS.CANCELED) }}
          </b-badge>
          <b-badge
            :variant="fields.status.includes(ORDER_STATUS.EXPIRED) ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addStatus(ORDER_STATUS.EXPIRED)"
          > {{ getOrderStatusText(ORDER_STATUS.EXPIRED) }}
          </b-badge>
          <b-badge
            :variant="fields.status.length === Object.keys(ORDER_STATUS).length ? 'primary' : 'light'"
            class="mx-2 pointer"
            @click="addAllStatus()"
          > Todos
          </b-badge>
        </h4>
      </div>
    </b-col>
    
    <b-col cols="12">
      <order-status
        :endDate="fields.endDate"
        :startDate="fields.startDate"
        :shopkeepersIds="fields.shopkeepersIds"
        origin="lojista"
      />
    </b-col>
    
    <b-col cols="12" class="mt-3">
      <b-row>
        <b-col cols="12" lg="7">
          <b-card >
            <b-row class="mb-3">
              <b-col cols="5">
                <span class="fs-24 font-weight-bold"> Gráfico geral </span>
              </b-col>
              <b-col cols="12" lg="12" class="mt-3">
                <SelectOrderStatus v-model="fields.generalGraphStatus" />
              </b-col>
            </b-row>
            <b-card-text>
              <b-row>
                <b-col cols="12">
                  <b-overlay :show="loadingGeneralGraph">
                    <GeneralGraph :ordersInPeriod="resultGraphic.ordersInPeriod" />
                  </b-overlay>
                </b-col>
              </b-row>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col  cols="12" lg="5">
          <b-row>
            <b-col cols="12" class="mb-3">
              <span class="fs-24 font-weight-bold"> Outros dados</span>
            </b-col>
            <b-col cols="12">
              <StatsCard
                formatToMoney
                text="Faturamento"
                :loading="loadingStatistics"
                :quantity="resultGraphic.invoicing"
              />
            </b-col>
            <b-col cols="12" class="mt-3">
              <StatsCard
                down
                formatToMoney
                text="Ticket médio"
                :loading="loadingStatistics"
                :quantity="resultGraphic.averageTicket"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">
        {{ pagination.total }} pedidos encontrados
      </h3>
      <b-button
        v-if="!generatingSpreadsheet"
        pill
        variant="success"
        @click="generateSpreadsheet()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Baixar planilha
      </b-button>
      <b-spinner v-else variant="success" label="Spinning"></b-spinner>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        responsive
        hover
        show-empty
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(status)="data">
          {{ getOrderStatusText(data.item.status) }}
        </template>
        <template #cell(totalValue)="data">
          {{ formatNumber(data.item.totalValue) }}
        </template>
        <template #cell(paymentType)="data">
          <span class="d-none d-md-block">{{ getPaymentTypeText(data.item.paymentType) }}</span>
        </template>
        <template #cell(actions)="data">
          <b-col style="width: 120px" class="pr-0">
            <b-button
              variant="outline-dark"
              size="sm"
              title="Detalhes do pedido"
              class="mr-2 mb-2"
              v-if="!data.item.editing"
              @click="$refs.orderDetails.toggleOpen({ orderId: data.item.id, uuid: data.item.uuid, dataModal: data.item })"
            >
              <i class="fas fa-eye"></i>
            </b-button>
          </b-col>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>
    <VideoManual ref="videoManual"/>
    <OrderDetails ref="orderDetails" :shopkeepersIds="fields.shopkeepersIds" />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx';

import { formatNumber } from '@/utils';

import ORDER_STATUS from 'Enums/Order/Status.js';

import PageTitle from 'Components/PageTitle.vue';
import makeToast from 'Mixins/makeToast';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import OrderDetails from 'Components/Order/OrderDetails.vue';
import OrderStatus from 'Components/Order/OrderStatus.vue';
import StatsCard from './StatsCard.vue';
import GeneralGraph from './GeneralGraph.vue';
import SelectOrderStatus from 'Components/Inputs/SelectOrderStatus.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import VideoManual from '@/components/VideoManual.vue';

export default {
  name: 'OrdersAppList',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
    OrderDetails,
    OrderStatus,
    StatsCard,
    GeneralGraph,
    SelectOrderStatus,
    VideoManual
  },
  data() {
    return {
      ORDER_STATUS,
      loadingGeneralGraph: false,
      loadingStatistics: false,
      generatingSpreadsheet: false,
      loading: false,
      showConfirmationPopover: false,
      currentOrderBeingEditedId: 0,
      fields: {
        shopkeepersIds: [],
        clientName: '',
        orderNumber: null,
        startDate: '',
        endDate: '',
        status: [],
        selectedOrders: {},
        generalGraphStatus: ORDER_STATUS.WAITING_PAYMENT,
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'uuid',
            label: 'Pedido',
            sortable: true,
          },
          {
            key: 'date',
            label: 'Data',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status Pagamento',
            sortable: true,
          },

          {
            key: 'clientName',
            label: 'Cliente',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell",
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'paymentType',
            label: 'Forma de Pagamento',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell",
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: 'totalValue',
            label: 'Valor total',
            sortable: true,
            headerClass: "d-none d-md-table-cell", 
            tdClass: "d-none d-md-table-cell" ,
            thClass: "d-none d-md-table-cell" 
          },
          {
            key: '',
            label: 'Status Entrega',
            sortable: true,
          },
          {
            key: '',
            label: 'Status Pedidos',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
      resultGraphic: {
        finished: 0,
        pendingToDelivery: 0,
        pendingToPay: 0,
        canceled: 0,
        visitants: 0,
        invoicing: 0,
        averageTicket: 0,
        productsOnCart: 0,
        ordersInPeriod: {
          filterBy: '',
          result: {},
        },
      },
      timer: null,
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    orderStatusItems() {
      const items = [];

      Object.keys(ORDER_STATUS).forEach((key) => {
        items.push({
          id: ORDER_STATUS[key],
          name: this.getOrderStatusText(ORDER_STATUS[key]),
        });
      });

      return items;
    },
  },
  watch: {
    'pagination.currentPage': function () {
      this.pesquisar();
    },
    'fields.startDate': function () {
      this.pesquisar();
    },
    'fields.endDate': function () {
      this.pesquisar();
    },
    'fields.generalGraphStatus': function () {
      this.pesquisar();
    },
  },
  created() {
    this.$set(this.fields, 'generalGraphStatus', ORDER_STATUS.WAITING_PAYMENT);
  },
  mounted() {
    this.fields.shopkeepersIds[0] = this.userTypeId();
    this.pesquisar();
  },
  methods: {
    formatNumber,
    ...mapActions('admin', ['getOrdersSummary']),
    ...mapActions('shopkeeper', ['getStatistics', 'getGeneralGraph']),
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.pesquisar();
      }, 800);
    },
    pesquisar() {
      this.list();
      this.getGraph();
      this.getStats();
    },
    getStats() {
      if (this.loadingStatistics) return;

      this.loadingStatistics = true;

      this.getStatistics({
        userId: this.userTypeId(),
        clerkId: this.whatClerkPermission(),
        startDate: this.fields.startDate,
        endDate: this.fields.endDate,
      })
        .then((response) => {
          const {
            finished,
            pendingToDelivery,
            pendingToPay,
            canceled,
            visitants,
            invoicing,
            averageTicket,
            productsOnCart,
          } = response.data.data || {};

          this.resultGraphic.finished = finished;
          this.resultGraphic.pendingToDelivery = pendingToDelivery;
          this.resultGraphic.pendingToPay = pendingToPay;
          this.resultGraphic.canceled = canceled;
          this.resultGraphic.visitants = visitants;
          this.resultGraphic.invoicing = invoicing;
          this.resultGraphic.averageTicket = averageTicket;
          this.resultGraphic.productsOnCart = productsOnCart;
        })
        .finally(() => {
          this.loadingStatistics = false;
        });
    },
    list() {
      this.loading = true;

      const {
        shopkeepersIds,
        clientName,
        orderNumber,
        startDate,
        endDate,
        status,
      } = this.fields;

      this.getOrdersSummary({
        currentPage: this.pagination.currentPage,
        shopkeepersIds,
        clerkId: this.whatClerkPermission(),
        clientName,
        orderNumber,
        startDate,
        endDate,
        status,
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 50;
          this.pagination.total = total || 0;

          this.$set(this.table, 'records', data || []);
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao trazer os pedidos', 'danger');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getGraph() {
      if (this.loadingGeneralGraph) return;

      this.loadingGeneralGraph = true;

      this.getGeneralGraph({
        userId: this.userTypeId(),
        startDate: this.fields.startDate,
        endDate: this.fields.endDate,
        generalGraphStatus: this.fields.generalGraphStatus,
      })
        .then((response) => {
          const { ordersInPeriod } = response.data.data || {};

          this.resultGraphic.ordersInPeriod = ordersInPeriod || {};
        })
        .finally(() => {
          this.loadingGeneralGraph = false;
        });
    },
    generateSpreadsheet() {
      if (!this.table.records || !this.table.records.length) return;

      this.generatingSpreadsheet = true;

      const clientsData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.table.records)
      );

      const excelFile = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de clientes');

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const fileName = `Lista de pedidos - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};

        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);

          if (key === 'status') {
            cell[`${tableColumn.label}`] = this.getOrderStatusText(record[key]);
            return;
          }

          if (key === 'paymentType') {
            cell[`${tableColumn.label}`] = this.getPaymentTypeText(record[key]);
            return;
          }

          if (key === 'totalValue') {
            cell[`${tableColumn.label}`] = formatNumber(record[key]);
            return;
          }

          cell[`${tableColumn.label}`] = record[key];
        });

        returnArray.push(cell);
      });

      return returnArray;
    },
    handleOrderNumber() {
      if (!this.fields.orderNumber) return;

      this.$set(this.fields, 'orderNumber', Math.abs(this.fields.orderNumber));
    },
    addStatus(userType) {
      if (this.fields.status.includes(userType)) {
        const index = this.fields.status.indexOf(userType);
        this.fields.status.splice(index, 1);
        this.pesquisar();
        return;
      }

      this.fields.status.push(userType);
      this.pesquisar();
    },
    addAllStatus() {
      Object.values(ORDER_STATUS).forEach((value) => {
        if (this.fields.status.includes(value)) return;

        this.fields.status.push(value);
      });

      this.pesquisar();
    },
    getPaymentTypeText(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
        pix: 'Pix',
        all: 'Boleto',
        wallet: 'Carteira',
      };

      return texts[type] || 'N/A';
    },
    getOrderStatusText(status) {
      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: 'Aguardando pagamento',
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.READY_FOR_PICKUP]: 'Pronto para retirada',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
        [ORDER_STATUS.EXPIRED]: 'Expirado',
      };

      return texts[status] || 'N/A';
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const homePermission = permissionClerk.find(element => element.name == NamePermission.ESTATISTICA);
  
        if(this.$route.meta.userType == UserTypes.BALCONISTA && homePermission.type == TypePermission.BALCONISTA){
          return this.dadosUsuario.id;
        }
      }
      return '';
    }
  },
};
</script>
